import { AppNotificationComponent } from './app-notification.component';

export default angular
  .module('sfMobile.componnents.app-notification', [
    'ngAnimate',
    'sfMobile.notifications',
    'sfMobile.services.pubsub',
  ])
  .component('sfAppNotification', AppNotificationComponent).name;
